
const _directiveDependencies = ['Templates', '$compile'];

class DeploymentWizardGeneratorDirective {

    constructor(Templates, $compile) {

        this.template = require('./deployment-wizard-generator.html');
        this.restrict = 'EA';
        this.replace = true;
        this.scope = {
            dynamicDirectiveTag: '=', // used to change directives on the fly,
            // DO NOT change the value of the directive when using the changeWizard fn
            // as a weird bug happens and the user gets stuck in the same modal.
            inputData: '=?', // used to pass around parameters between deployment modals, the inputData is marked as optional
            changeWizard: '&', // used to pass a method in the directive scope, so it can be called within our directive,
            showSuccessScreen: '&',
            deployOnDeviceSuccess: '&',
        };
        this.link = (scope, element) => {

            // every time we change the directive we recompile
            scope.$watch('dynamicDirectiveTag', (newValue) => {

                element.html($compile(newValue)(scope));

            });

        };

    }

}

_directiveDependencies.push((Templates, $compile) =>
    new DeploymentWizardGeneratorDirective(Templates, $compile));

angular.module('directives')
    .directive('deploymentWizardGenerator', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/wizard-generator/deployment-wizard-generator.js